import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { DNode } from '@dojo/framework/core/interfaces';

import { QuestionQueueType } from '../../interfaces';
import { ScoreRollup } from '../../support/score-rollup';
import { QuestionQueue } from '../../support/questionqueue';
import { QFAuditBase } from './auditbase';

import css from '../../css/questionfeedback.m.css';

@theme(css)
export class PosttestQuestionFeedback extends QFAuditBase {
	protected render_page(): DNode[] {
		const { isPlaceholder } = this.properties.localizedBundle;
		if (isPlaceholder) {
			return [];
		}
		const { isrunning, instancekey = '', quizstore } = this.properties;
		const { finalize, startquiz, svc } = this;

		switch (isrunning) {
			case 'quiz':
				return [
					w<QuestionQueueType>(QuestionQueue, {
						key: `${instancekey}-queue`,
						svc,
						finalize,
						startquiz,
						quizstore
					})
				];

			case 'audit':
				return this.run_audit();

			case 'final':
				return this.run_quiz_end();

			default:
				return this.run_quiz_begin();
		}
	}

	protected render(): DNode {
		const { quiz, info, key, quizstore } = this.properties;
		const hasdata = quiz && info;
		!hasdata && this.load_quiz();

		return v(
			'div',
			{ key, xqa: `progression posttest question-feedback` },
			hasdata
				? [w(ScoreRollup, { key: `rollup-${key}`, quizstore } as any, this.render_page())]
				: this.render_loading()
		);
	}
}
